document.addEventListener("DOMContentLoaded", function () {
  accordion();
});

// Cases Slider
function accordion() {
  const elements = document.querySelectorAll('.ac-trigger');
   
      if (elements.length === 0) {
        return;
      }
      Array.from(elements).forEach((element) => {
        element.addEventListener('click', toggleAccordion);
      });
      function toggleAccordion(e) {
        e.preventDefault();
        const parent = e.target.closest('.ac-wrapper');
  
        if (parent.classList.contains('active')) {
          parent.classList.remove('active');
        } else {
          parent.classList.add('active');
        }
      }
}